import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enCommon from './local/en/common';
import idCommon from './local/id/common';
import zhCommon from './local/zh/common';
import zhHantCommon from './local/zh-Hant/common';
import esCommon from './local/es/common';
import ptCommon from './local/pt/common';
import arCommon from './local/ar/common';

// 将扁平键名按命名空间分组
function groupByNamespace(flat: Record<string, string>) {
  const result: Record<string, Record<string, string>> = {};
  Object.entries(flat).forEach(([key, value]) => {
    const colonIdx = key.indexOf(':');
    if (colonIdx !== -1) {
      const ns = key.slice(0, colonIdx);
      const k = key.slice(colonIdx + 1);
      if (!result[ns]) result[ns] = {};
      result[ns][k] = value;
    } else {
      if (!result['translation']) result['translation'] = {};
      result['translation'][key] = value;
    }
  });
  return result;
}

function buildResources(flat: Record<string, string>) {
  return groupByNamespace(flat);
}

const enNs = buildResources(enCommon);
const idNs = buildResources(idCommon);
const zhNs = buildResources(zhCommon);
const zhHantNs = buildResources(zhHantCommon);
const esNs = buildResources(esCommon);
const ptNs = buildResources(ptCommon);
const arNs = buildResources(arCommon);

const namespaces = ['common', 'upload', 'pdfToWord', 'pdfToExcel', 'pdfToPpt', 'imageConvert', 'pdfToolsPage', 'home', 'footer'];

i18n
  .use(initReactI18next)
  .init({
    lng: 'id',
    fallbackLng: 'id',
    debug: false,
    ns: namespaces,
    defaultNS: 'common',
    resources: {
      en: enNs,
      id: idNs,
      zh: zhNs,
      'zh-Hant': zhHantNs,
      es: esNs,
      pt: ptNs,
      ar: arNs,
    },
    interpolation: {
      escapeValue: false,
    },
  });

// 语言切换时处理 RTL 和 lang 属性
const htmlElement = document.documentElement;

const applyLangDir = (lng: string) => {
  if (lng === 'ar') {
    htmlElement.setAttribute('dir', 'rtl');
    htmlElement.setAttribute('lang', 'ar');
  } else {
    htmlElement.setAttribute('dir', 'ltr');
    htmlElement.setAttribute('lang', lng);
  }
};

i18n.on('languageChanged', applyLangDir);
applyLangDir(i18n.language);

// 持久化语言选择到 localStorage
const savedLang = localStorage.getItem('pdf-tools-lang');
if (savedLang) {
  i18n.changeLanguage(savedLang);
}

export default i18n;
